<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'OrderCourseOverrides',
  props: ['orderId'],
  components: {
    
  },
  mounted () {
    // this.loading = true
    // this.fetchOrderTypeOverrides()
    // .then(() => {
    //   console.log('overrides fetched')
    //   this.loading = false 
    // });
  },
  data () {
    return {
      flag: false,
      searchTerms: '',
      test: false,
      selectedCourse: null,
      selectedOverrides: [],
      loading: false,
      pagination: {
        page: 1,
        rowsNumber: 10
      },
      columns: [
        {
          name: 'COURSE_NAME',
          required: true,
          label: 'Course Name',
          field: 'COURSE_NAME',
          sortable: true
        },
        { name: 'COURSE_LENGTH', label: 'Course Length', field: 'COURSE_LENGTH_HOURS', sortable: true },
        { name: 'PRICE', label: 'Price', field: 'PRICE', sortable: true },
        { name: 'MIN_AMOUNT', label: 'Min Amount', field: 'MIN_AMOUNT', sortable: true },
        { name: 'MAX_AMOUNT', label: 'Max Amount', field: 'MAX_AMOUNT', sortable: true },
      ],
    }
  },
  computed: {
    ...mapState('orders', {
      courseOverrides: (state) => state.courseOverrides
    }),
    ...mapGetters('users', [
      'autoCompleteOptions',
    ]),
    ...mapGetters('orders', [
      'courseOverrideList'
    ]),
    ...mapGetters([
      'shippingTypeOptions'
    ])

  },
  methods: {
    ...mapMutations('orders', [
      'addCourseOverride',
      'removeCourseOverride',
      'addOverrideShippingMethod',
      'removeOverrideShippingMethod',
      'updateSelectedCourseOverrides'
    ]),
    ...mapActions('users', [
      'fetchAutoComplete',
    ]),
    ...mapActions('orders', [
      'fetchOrderTypeOverrides'
    ]),
    remainingShippingTypeOptions (shippingMethods, shippingTypeId) {
      let remainingOptions = _.filter(this.shippingTypeOptions, shippingType => {
        let found = false
        _.each(shippingMethods, shippingMethod => {
          if(shippingMethod.LK_SHIPPING_TYPE_ID === shippingType.value) {
            found = true
          }
        })
        return !found
      })
      if(shippingTypeId) {
        const selectedShippingTypeOption = _.find(this.shippingTypeOptions, shippingType => shippingType.value === shippingTypeId)
        remainingOptions.unshift(selectedShippingTypeOption)
      }
      return remainingOptions
    },
    addShippingMethod(overrideIndex) {
      this.addOverrideShippingMethod({ overrideIndex})
    },
    removeShippingMethod(overrideIndex, shippingMethodIndex) {
      this.removeOverrideShippingMethod({ overrideIndex, shippingMethodIndex })
    },
    forceSingleDefault(shippingMethodIndex, shippingMethods) {
      shippingMethods.forEach(shippingMethod => shippingMethod.IS_DEFAULT = false)
      shippingMethods[shippingMethodIndex].IS_DEFAULT = true
    },
    onClickOverrideCheckbox() {
      this.updateSelectedCourseOverrides(this.selectedOverrides)
    },
    onCourseSearch(terms, done) {
      return this.fetchAutoComplete({ s: this.searchTerms })
      .then(() => done(this.autoCompleteOptions))
    },
    onSelect(test) {
      this.selectedCourse = test.item;
    }
  }
}
</script>

<template>
<div class="">
  <div class="row">
    <q-table
      selection="multiple"
      :data="courseOverrideList"
      :columns="columns"
      :loading="loading"
      :selected.sync="selectedOverrides"
      :pagination.sync="pagination"
      @request="fetchOrderTypeOverrides"
      row-key="ORDER_TYPE_OVERRIDE_ID"
      class="full-width"
    >
      <q-tr slot="header" slot-scope="props">
        <q-th auto-width>
          <q-checkbox :value="null" indeterminate-icon="unfold_more" class="q-mr-md" />
          <q-checkbox
            v-if="props.multipleSelect"
            v-model="props.selected"
            indeterminate-value="some"
          />
        </q-th>
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          {{ col.label }}
        </q-th>
      </q-tr>

      <template slot="body" slot-scope="props">
        <q-tr :props="props">
          <q-td>
            <q-checkbox color="primary" v-model="props.expand" checked-icon="expand_less" unchecked-icon="expand_more" class="q-mr-md" />
            <q-checkbox color="primary" v-model="props.selected" @click.native="updateSelectedCourseOverrides(selectedOverrides)"/>
          </q-td>
          <q-td key="COURSE_NAME" :props="props">{{ props.row.COURSE.COURSE_NAME }}</q-td>
          <q-td  key="COURSE_LENGTH" :props="props">{{ props.row.COURSE.COURSE_LENGTH_HOURS}}hrs {{props.row.COURSE.COURSE_LENGTH_MINUTES}}min</q-td>
          <q-td  key="PRICE" :props="props">{{ props.row.PRICE }}</q-td>
          <q-td key="MIN_AMOUNT" :props="props">{{ props.row.MIN_AMOUNT }}</q-td>
          <q-td key="MAX_AMOUNT" :props="props">{{ props.row.MAX_AMOUNT }}</q-td>
        </q-tr>
        <q-tr v-show="props.expand" :props="props">
          <q-td colspan="100%">
            <div class="row">
              <q-field class="q-pa-md col-4">
                <q-input stack-label="Price Override" type="number" prefix="$" v-model="props.row.PRICE" @input="props.selected = false" />
              </q-field>
              <q-field class="q-pa-md col-4">
                <q-input stack-label="Minimum Amount Override" type="number" v-model="props.row.MIN_AMOUNT" @input="props.selected = false" />
              </q-field>
              <q-field class="q-pa-md col-4">
                <q-input stack-label="Maximum Amount Override" type="number" v-model="props.row.MAX_AMOUNT" @input="props.selected = false" />
              </q-field>
            </div>
            <h6> Shipping Methods
                <q-btn 
                  icon="add" id="addShippingType"
                  @click="addShippingMethod(props.row.overrideIndex); props.selected = false"
                  v-show="props.row.SHIPPING_METHODS.length < shippingTypeOptions.length"
                >
                
                  <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">Add a Shipping Type</q-tooltip>
                </q-btn>
                <div v-show="props.row.SHIPPING_METHODS.length === 0">
                  <span class="label bg-primary">Please Add a Shipping Type!</span>
                </div> 
              </h6>
            <div class="row" v-for="(shippingMethod, shippingMethodIndex) in props.row.SHIPPING_METHODS" :key="shippingMethodIndex">
              <q-field 
                class="q-pa-md col-3"
              >
                <q-select float-label="Shipping Type" v-model="shippingMethod.LK_SHIPPING_TYPE_ID" 
                  :options="remainingShippingTypeOptions(props.row.SHIPPING_METHODS, shippingMethod.LK_SHIPPING_TYPE_ID)"
                  @input="props.selected = false"
                />
              </q-field>
              <q-field 
                class="q-pa-md col-2">
                <q-input type="number" stack-label="Price" prefix="$" 
                  v-model="shippingMethod.PRICE" 
                  @input="props.selected = false"
                />   
              </q-field>
              <q-field 
                class="q-pa-md col-2">
                <q-input type="number" stack-label="Item Limit" prefix="x" 
                  v-model="shippingMethod.ITEM_LIMIT" 
                  @input="props.selected = false"
                />   
              </q-field>
              <q-field 
                class="q-ma-lg col-2">
                <q-toggle
                  v-model="shippingMethod.IS_DEFAULT"
                  @input="forceSingleDefault(shippingMethodIndex, props.row.SHIPPING_METHODS)"
                  label="Default"
                />
              </q-field>
              <q-btn size="md" class="float-right" icon="delete" @click="removeShippingMethod(props.row.overrideIndex, shippingMethodIndex); props.selected = false">
              </q-btn> 
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</div>
</template>

<style scoped>

</style>